import { useGridApiContext } from "@mui/x-data-grid";
import React, { useContext, useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { Card, CardBody, Modal, Row, Col } from "reactstrap";
import { FEE_COMPONENTS } from ".";
import CustomButton from "../../../../../../../components/CustomButton";
import ConsessionTreeClassification from "../../../../common/commonComponents/treeView";
import { endpoint } from "../../../../common/constant";
import { fetchAllPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
  successToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import CommonInput from "../../../../common/formFeilds/input/commonInput";
import CustomLoader from "../../../../common/commonComponents/Loader/loader";
import { getCurrentYearAndCoursePricingDetail, getFilteredSubCategory, getLumpsumCategoryData } from "../common";
import moment from "moment";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { errorMgsForPaymentLumpsum } from "./constants";
import SelectLumpSumCategory from "./SelectLumpSumCategory";

const lumpsumCategory = ["full first year", "full upfront", "year on year"];

const LUMPSUM_CONCESSIONS = new Set([
  "LUMPSUM_First_Year",
  "LUMPSUM_Year_On_Year",
  "LUMPSUM_Full_Course",
]);

const PAYMENT_MODE_KEYWORDS = new Set(["PAYMENT", "LOAN"]);

const extractConcessionType = (item) =>
  item?.concessionMethodType || item?.category?.concessionMethodType || "";

const normalizeTypeParts = (type) =>
  type.split(/[_\-\s]/).map(part => part.toUpperCase());

export const hasLumpsumConcession = (list) =>
  list.some(item => LUMPSUM_CONCESSIONS.has(extractConcessionType(item)));

export const hasPaymentOrLoanConcession = (list) =>
  list.some(item =>
    normalizeTypeParts(extractConcessionType(item)).some(part =>
      PAYMENT_MODE_KEYWORDS.has(part)
    )
  );



const CategorySelector = (params) => {
  const {
    allAppliedConcList,
    id,
    value,
    field,
    row,
    applicationDetails,
    allCategories,
    userPermissions,
    prospectusSlabs,
    isCategorySelectorDisabled = () => {},
    concessionModificationAllowed,
    isConcessionReversalMasterFlow,
    updateConcessionData,
    currentConcessionData = {},
    validateLumSumpOutstanding
  } = params;
  const apiRef = useGridApiContext();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value || currentConcessionData);
  const [concessionSlabData, setConcessionSlabData] = useState([]);
  const [concessionDetails, setConcessionDetails] = useState(null);
  const [inputVal, setInputVal] = useState(row?.scholarshipCriteriaValue);
  const [loading, setLoading] = useState(false);
  const [concessionCategory, setConcessionCategory] = useState("");

  // this all data contain categories, subCategory details
  const [allData, setAllData] = useState(allCategories);
  const [filteredData, setFilteredData] = useState(allCategories);
  const [searchedStr, setSelectedStr] = useState("");
  console.log(value, "value")
  useEffect(() => {
    if (selected && !isConcessionReversalMasterFlow) {
      getCategoryDetails(selected);
    }
  }, [selected]);

  useEffect(() => {
    const consolidatedData = allCategories.filter(
      (c) => c.categoryCode === row?.code?.[0]?.value
    );
    setAllData(consolidatedData);
    setFilteredData(consolidatedData);
    setSelectedStr("");

    if (!concessionModificationAllowed && !isConcessionReversalMasterFlow) {
      const lumpSumCategoryData = getLumpsumCategoryData(consolidatedData);
      setAllData(lumpSumCategoryData);
      setFilteredData(lumpSumCategoryData);
    }
    if(isConcessionReversalMasterFlow){
      
      const filteredData = getFilteredSubCategory(consolidatedData);
      setAllData(filteredData);
      setFilteredData(filteredData);
    }
  }, [row, allCategories, concessionModificationAllowed]);

  useEffect(() => {
    if (searchedStr) {
      applyFilter();
    } else {
      setFilteredData(allData);
    }
  }, [searchedStr]);

  const applyFilter = () => {
    // filter in sub sub categories
    // filter in sun categories
    // filter in categories
    const filteredResult = filterData(allData, searchedStr);
    setFilteredData(filteredResult);
  };

  function filterData(data, searchValue) {
    const filteredData = [];
    const currentData = JSON.parse(JSON.stringify(data));
    currentData.forEach((category) => {
      if (
        category.categoryDispVal
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      ) {
        filteredData.push(category);
        return;
      }

      const subcategories = [];

      category.subCategories.forEach((subcategory) => {
        if (
          subcategory.subCategoryDispVal
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        ) {
          subcategories.push(subcategory);
          return;
        }

        const subsubcategories = [];

        subcategory.subSubCategory.forEach((subsubcategory) => {
          if (
            subsubcategory.subSubCategoryDisplayValue
              .toLowerCase()
              .includes(searchValue.toLowerCase())
          ) {
            subsubcategories.push(subsubcategory);
          }
        });

        if (subsubcategories.length > 0) {
          subcategory.subSubCategory = subsubcategories;
          subcategories.push(subcategory);
        }
      });

      if (subcategories.length > 0) {
        category.subCategories = subcategories;
        filteredData.push(category);
      }
    });

    return filteredData;
  }

  useEffect(() => {
    if (value) {
      setSelected(value);
      setConcessionCategory(params?.row?.categoryDetails);
    } else {
      setSelected(null);
      setConcessionDetails(null);
      setInputVal("");
      setConcessionCategory("");
    }
  }, [value]);

  const getCategoryDetails = async (category) => {
    
    if(!category.id)return false; 
    setLoading(true);
    console.log(category);
    try {
      let concessionsResp = await fetchAllPromisedData(
        category.isSubSubCategory
          ? `${endpoint.getConcessionSlabBySubSubCategory}/${category.id}?status=ACTIVE`
          : `${endpoint.getConcessionSlabBySubCategory}/${category.id}?status=ACTIVE`
      );

      const detailsResp = await fetchAllPromisedData(
        category.isSubSubCategory
          ? `${endpoint.subSubCategory}/${category.id}`
          : `${endpoint.subCategory}/${category.id}`
      );
      setLoading(false);
      if (concessionsResp && detailsResp) {
        if (open && detailsResp?.availability === "AUTO") {
          failureToast(
            "This is an auto-apply concession. Please use the auto concession feature to apply it."
          );
          setSelected(null);
          return;
        }
        setConcessionSlabData(concessionsResp);
        setConcessionDetails(detailsResp);
      } else {
        failureToast("Failed to fetch Data");
      }
    } catch (error) {
      failureToast("Failed to fetch Data");
      setLoading(false);
    }
  };

  const onSubCategoryClick = (c, sc) => {
    if (sc.subCategoryExternalId === selected?.subCategoryExternalId) {
      setSelected(null);
      return;
    }
    if (
      prospectusSlabs?.find((i) => i.categoryId === c.id && i.id !== row.id)
    ) {
      failureToast("This concession category is already added.");
      return;
    }
    if (sc.subSubCategory.length === 0) {
      setConcessionCategory(c);
      setSelected({
        ...sc,
        isSubSubCategory: false,
        categoryCode: c?.categoryCode,
        categoryDispVal: c?.categoryDispVal,
      });
      setInputVal("");
    }
  };

  const onSubSubCategoryClick = async (c, sc, ssc, sname) => {
      
    const isLumpSum  = sc?.isLumpSum
    if (ssc.subSubCategoryExternalId === selected?.subSubCategoryExternalId) {
      setSelected(null);
      return;
    }
    if (
      prospectusSlabs?.find((i) => i.categoryId === c.id && i.id !== row.id)
    ) {
      failureToast("This concession category is already added.");
      return;
    }
    setConcessionCategory(c);

    const concessionType = ssc?.concessionType?.split("_")?.[0] ?? "";
    const concessionMethodType = ssc?.concessionType ||ssc?.masterType ;

    if(validateLumSumpOutstanding){
    const  isValidOutstanding =  validateLumSumpOutstanding(ssc?.concessionType)
     if(!isValidOutstanding)return false;
    }
    if ( isLumpSum && concessionType === "LUMPSUM" && !isConcessionReversalMasterFlow) {
      
      const {year} = await getCurrentYearAndCoursePricingDetail(applicationDetails) || {};
      if (!year) {
        failureToast("Student is not eligible for the selected concession.");
        return;
      }
      // if (year === 1 && concessionMethodType.toLowerCase() === "lumpsum_year_on_year") {
      //   failureToast("Student is not eligible for the selected concession.");
      //   return;
      // }
      if (
        year > 1 &&
        (concessionMethodType.toLowerCase() === "lumpsum_year_on_year" || concessionMethodType === "LUMPSUM_Full_Course")
      ) {
        failureToast("Student is not eligible for the selected concession.");
        return;
      }
    }

    setSelected({
      ...ssc,
      isSubSubCategory: true,
      concessionMethodType: concessionMethodType,
      isLumpsum: sc?.isLumpSum,
      categoryCode: c?.categoryCode,
      categoryDispVal: c?.categoryDispVal,
      subCategoryDispVal: sc?.subCategoryDispVal,
    });
    setInputVal("");
  };

  const onlumsumClick = (lumpsum) => {
    // setSelected({ ...lumpsum, isLumpsum: true });
    // setInputVal('');
  };

  const getSuitedSlab = () => {
    let suitedSlabs = [];
    let invalidMessages = [];
    // First, filter out slabs based on the scholarship criteria
    if (concessionDetails?.scholarshipCriteria === "QUALIFIED") {
      suitedSlabs =
        concessionSlabData?.filter((slab) =>
          isPastOrFutureDate(slab?.effectiveFrom, slab?.effectiveTo)
        ) || [];
    } else {
      suitedSlabs =
        concessionSlabData?.filter(
          (item) => +inputVal >= +item.rangeFrom && +inputVal <= +item.rangeTo
        ) || [];
    }

    // Then, filter out the slabs based on all conditions and keep track of errors
    suitedSlabs = suitedSlabs.filter((suitedSlab) => {
      if (!suitedSlab) {
        invalidMessages.push("No slab with the given criteria found.");
        return false;
      }

      if (
        suitedSlab.academicCareerId[0] !== 0 &&
        !suitedSlab.academicCareerId.includes(
          applicationDetails.academicCareerId
        )
      ) {
        invalidMessages.push("Academic Career does not match.");
        return false;
      }

      if (
        suitedSlab.businessAreaId[0] !== 0 &&
        !suitedSlab.businessAreaId.includes(applicationDetails.businessAreaId)
      ) {
        invalidMessages.push("Business Area does not match.");
        return false;
      }

      if (
        suitedSlab.courseCategoryId[0] !== 0 &&
        !suitedSlab.courseCategoryId.includes(
          applicationDetails.courseCategoryId
        )
      ) {
        invalidMessages.push("Course Category does not match.");
        return false;
      }
      if (
        suitedSlab.academicGroupId[0] !== 0 &&
        !suitedSlab.academicGroupId.includes(applicationDetails.academicGroupId)
      ) {
        return false;
      }

      if (
        suitedSlab.courseId[0] !== 0 &&
        !suitedSlab.courseId.includes(applicationDetails.courseId)
      ) {
        invalidMessages.push("Course Id does not match.");
        return false;
      }

      if (
        suitedSlab.termId[0] !== 0 &&
        !suitedSlab.termId.includes(applicationDetails.termId)
      ) {
        invalidMessages.push("Term Id does not match.");
        return false;
      }

      // If the slab matches all conditions, return true
      return true;
    });

    if (suitedSlabs.length === 0) {
      return {
        suitedSlab: null,
        message:
          "The Concession is not available for the selected course, term and business area.",
      };
    }

    return {
      suitedSlab: suitedSlabs[0],
      message: "",
    };
  };

  const isStudentEligibleExAakashian = async () => {
    try {
      const resp = await fetchAllPromisedData(
        `${endpoint.configExAakashian.validate}/${applicationDetails?.psid}`,
        true
      );
      if (resp?.code === 200) {
        if (resp?.data) {
          successToast(
            `${applicationDetails?.psid} is eligible for ex-aakashian concession.`
          );
          return true;
        } else {
          failureToast(
            "Student Doesn't meet the Ex-aakashian criteria for applying this Concession"
          );
          return false;
        }
      }
      return false;
    } catch (err) {
      console.log(err);
    }
  };

  const exAakashianConcAlreadyApplied = (exAakashianCategoryId, rowId) => {
    // console.log('rowId---->>>', rowId);
    let isExAakashianConcAlreadyApplied = false;
    Array.isArray(prospectusSlabs) &&
      prospectusSlabs.forEach((slab) => {
        if (slab?.categoryId === exAakashianCategoryId && slab?.id !== rowId)
          isExAakashianConcAlreadyApplied = true;
      });
    return isExAakashianConcAlreadyApplied;
  };

  const isPastOrFutureDate = (sDate, eDate) => {
    const today = moment(new Date());
    return (
      moment(sDate).startOf("day") <= today &&
      today <= moment(eDate).endOf("day")
    );
  };

  const handleSave = async () => {
    if (checkForPaymentOrLumpsum(selected)) return;
    if (isConcessionReversalMasterFlow) {
      
      updateConcessionData(selected);
      setOpen(false);
      return;
    }

    console.log(concessionCategory, "concessionCategory");
    const { suitedSlab, message } = getSuitedSlab();
    if (concessionCategory?.categoryDispVal?.toLowerCase() === "ex-aakashian") {
      // console.log('category---->>>',concessionCategory);
      if (
        exAakashianConcAlreadyApplied(concessionCategory?.id, params?.row?.id)
      ) {
        failureToast("Ex-aakashian concession category already added");
        return;
      }
      const isEligible = await isStudentEligibleExAakashian();
      if (!isEligible) return;
    }

    const isValidSlab = isPastOrFutureDate(
      suitedSlab?.effectiveFrom,
      suitedSlab?.effectiveTo
    );
    if (!isValidSlab) {
      failureToast(
        "The Applied concession is expired, try contacting your administrator or try applying for another concession."
      );
      return;
    }

    if (suitedSlab && message === "") {
      apiRef.current.setEditCellValue({
        id,
        field,
        value: selected?.isLumpsum
          ? { ...selected, feeComponent: concessionDetails?.feeComponent ?? [] }
          : selected,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "scholarshipCriteriaValue",
        value: selected?.isLumpsum ? 0 : +inputVal,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "scholarshipCriteria",
        value: concessionDetails?.scholarshipCriteria,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "concessionSlabId",
        value: suitedSlab?.id || null,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "adminFeeConcession",
        value: suitedSlab?.admissionFee || 0,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "regFeeConcession",
        value: suitedSlab?.regFee || 0,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "classFeeConcession",
        value: suitedSlab?.classFee || 0,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "techFeeConcession",
        value: suitedSlab?.techFee || 0,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "tutionFeeConcession",
        value: suitedSlab?.tuitionFee || 0,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "concessionParameter",
        value: concessionDetails?.concessionParameter,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "categoryId",
        value: concessionCategory?.id ?? params?.row?.categoryId,
      });
      apiRef.current.setEditCellValue({
        id,
        field: "isNewSlab",
        value: true
      });
      setOpen(false);
    } else {
      failureToast(message);
    }
  };

  const onClose = () => {
    if (!inputVal) {
      setSelected(null);
      setConcessionDetails(null);
      apiRef.current.setEditCellValue({ id, field, value: null });
    } else {
      apiRef.current.setEditCellValue({ id, field, value: value });
    }
    setOpen(false);
  };

  const onInputChange = (val) => { // val is the string from the input
    // Allow empty string or just a minus sign
    if (val === "" || val === "-") {
      setInputVal(val);
      return;
    }
  debugger
    // Check if it's a valid number format
    if (/^-?\d*\.?\d*$/.test(val)) {
      const numericVal = parseFloat(val);
  
      // 1. Define Max Value based on criteria
      let maxVal = 9999999;
      switch (concessionDetails?.scholarshipCriteria) {
        case "PERCENTAGE":
        case "PERCENTILE":
          maxVal = 100;
          break;
        case "RANK":
          maxVal = 9999999;
          break;
        case "MARKS":
        case "GRADES":
          maxVal = 9999;
          break;
        default:
          maxVal = 9999999;
      }
  
      // 2. Define Min Value. Default to -100 as requested.
      let minVal = -100; // <-- The new minimum value
      // Override minVal for cases that cannot be negative
    
      
      // 3. Validate against both min and max
      if (numericVal >= minVal && numericVal <= maxVal) {
        setInputVal(val); // Set the valid value
      }
    }
  };

  const isDisabled = () => {
    if(isConcessionReversalMasterFlow && selected?.id ) return false
    if (
      concessionDetails?.scholarshipCriteria === "QUALIFIED" ||
      selected?.isLumpsum
    ) {
      return false;
    } else {
      
      if (selected === null || inputVal === "") {
        return true;
      } else {
        return false;
      }
    }
  };

  const checkForPaymentOrLumpsum = (selected) => {
    const errorMsg = errorMgsForPaymentLumpsum;
    const selectedIsLumpsum = selected?.isLumpsum === true;
    const selectedIsPaymentMode = selected?.masterType === "Payment Mode";
  
    const appliedConcessions = [...prospectusSlabs];
  
    if (selectedIsLumpsum && hasPaymentOrLoanConcession(appliedConcessions)) {
      failureToast(errorMsg);
      return true;
    }
  
    if (selectedIsPaymentMode && hasLumpsumConcession(appliedConcessions)) {
      failureToast(errorMsg);
      return true;
    }
  
    return false; // No conflict
  };
  

  const content = (
    <span
      style={{
        overflow: "hidden",
        display: "block",
        textOverflow: "ellipsis",
        maxWidth: "85%",
      }}
    >
      {params.value?.subSubCategoryDisplayValue ??
        params.value?.subCategoryDispVal ??
        params.value?.displayVal ??
        "Select"}
    </span>
  );
  return (
    <>
      {isConcessionReversalMasterFlow ? (
        <SelectLumpSumCategory
          methodType={currentConcessionData?.concessionMethodType}
          currentConcessionData = {currentConcessionData} 
          onClick={() => setOpen(true)}
        />
      ) : (
        <CustomButton
          content={content}
          permissionType={"R"}
          forTable={false}
          permissionSet={userPermissions}
          onClick={() => row.code.length !== 0 && setOpen(true)}
          outline={true}
          className="w-100 bg-light-blue"
          disabled={isCategorySelectorDisabled(row)}
        />
      )}

      <Modal isOpen={open} centered={true}>
        <Card className="mb-0">
          <CardBody>
            <Row className="d-flex justify-content-between align-items-center pl-3 pr-3 mb-3">
              <h2>Select category</h2>
              <IoClose
                size={20}
                style={{ cursor: "pointer" }}
                onClick={onClose}
              />
            </Row>
            <Row className="mb-3 w-100 p-2 ">
              <Col md="12">
                <AInput
                  placeholder="Search by category, sub-category or sub-sub-category"
                  value={searchedStr}
                  handler={(e) => setSelectedStr(e)}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{ overflow: "scroll", maxHeight: "500px" }}
            >
              <ConsessionTreeClassification
                classificationData={filteredData}
                fetching={false}
                isFilterApplied={false}
                onCategoryClick={(c) => {}}
                onSubCategoryClick={onSubCategoryClick}
                onSubSubCategoryClick={onSubSubCategoryClick}
                onlumsumClick={onlumsumClick}
                showSelectBtn={true}
                showSelectBtnForConcessionOnly={true}
                selected={selected}
                applicationDetails={applicationDetails}
                forStudentCharges={true}
                // expandedArr={[`${selected?.categoryId}-c`, `${selected?.isSubCategory ? selected?.id : selected?.subCategoryId}-sc`, `${selected?.isSubSubCategory ? selected?.id : ''}-ssc`]}
              />
            </Row>
            {loading ? (
              <CustomLoader loaderHeight={"129px"} />
            ) : (
              <>
                {selected &&
                  concessionDetails?.scholarshipCriteria !== "QUALIFIED" &&
                  concessionDetails?.scholarshipCriteria &&
                  !selected?.isLumpsum &&
                  !lumpsumCategory.includes(
                    params.value?.subSubCategoryDisplayValue?.toLowerCase()
                  ) && (
                    <>
                      <div>
                        Enter student's{" "}
                        {concessionDetails?.scholarshipCriteria.toLowerCase()}
                      </div>
                      <CommonInput
                        type={"text"}
                        defaultValue={inputVal}
                        placeHolder={""}
                        maxLength={400}
                        onChange={onInputChange}
                        forTable={false}
                        mandatory={true}
                        allowedSomeSpecialCharacters = {false}
                      />
                    </>
                  )}
                <CustomButton
                  content={"Save"}
                  permissionType={"C,U"}
                  forTable={false}
                  permissionSet={userPermissions}
                  onClick={handleSave}
                  disabled={isDisabled()}
                />
              </>
            )}
          </CardBody>
        </Card>
      </Modal>
    </>
  );
};

export default CategorySelector;
